import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView'
import { ReactComponent as BackIcon } from 'assets/images/icons/back.svg'
import { ChangeLogitems } from '../styles'
import { BackButton } from 'modules/subscription/styles'
import { handleExternalLink } from 'utils/helpers'

export function ProductUpdates(props) {
  return (
    <div style={{cursor: 'default'}}>
      <div className='d-flex justify-content-between py-3 px-3'>
        <div>
          <BackButton
            href='/'
            onClick={(e) => {
              e.preventDefault()
              props.set_showProductUpdate(false)
            }}>
            <BackIcon /> Back
          </BackButton>
        </div>
        <a target='_blank' rel='noreferrer' className='text-gray' onClick={handleExternalLink} href={`${process.env.REACT_APP_API_BASE_URL}feedback/${props.user.email}`}>
          <small>Give us feedback</small>
        </a>
      </div>
      <div>
        <ChangeLogitems>
          {props.changelog.map((log) => (
            <div className='changelog-item'>
              <div className='version_number'>
                <span className='bull'>&bull;</span>
                {log.version_number}
              </div>
              <div className='logContent'>
                <FroalaEditorView model={log.content} />
              </div>
            </div>
          ))}
        </ChangeLogitems>
      </div>
    </div>
  )
}
